import { render, staticRenderFns } from "./AccountVerifyModal.vue?vue&type=template&id=4f06f1b0&scoped=true"
import script from "./AccountVerifyModal.vue?vue&type=script&lang=js"
export * from "./AccountVerifyModal.vue?vue&type=script&lang=js"
import style0 from "./AccountVerifyModal.vue?vue&type=style&index=0&id=4f06f1b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f06f1b0",
  null
  
)

export default component.exports